import styles from "./Emailme.module.css";

const EmailMe = () => {
  return (
    <div className={styles.main}>
      <div className={styles.text}>
        If you have any ideas or questions about the fields in which I work, as
        well as the contents of this page, including books and tools, you can
        contact me via email. Also, if you see an interesting project or article
        that you found to be interesting or useful to me, please send it to me.
        Thanks
      </div>
      <div className={styles.email}>Sajad.Kolahchi@gmail.com</div>
    </div>
  );
};

export default EmailMe;
